import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    groupData: []
}

const AnalyticDashboardSlice = createSlice({
    name: 'analyticsDashboard',
    initialState,
    reducers: {
        handleGroupData(state, action) {
            state.groupData = action.payload
        }
    }
})

export const { handleGroupData } = AnalyticDashboardSlice.actions
export default AnalyticDashboardSlice.reducer